export const INVOICE_REVIEW_STATUS = {
  '1': '<span class="w-100 fw-bold m-1 py-2 px-3 text-warning bg-warning-subtle rounded">PENDING</span>',
  '2': '<span class="w-100 fw-bold m-1 py-2 px-3 text-danger bg-danger-subtle rounded">FLAGGED</span>',
  '3': '<span class="w-100 fw-bold m-1 py-2 px-3 text-success bg-success-subtle rounded">APPROVED</span>'
};

